import React, { useEffect, useState } from 'react';
import { Link } from 'lucide-react';
import { fetchText } from '../utils/api';

/**
 * The Related Services Page component, providing information about other services.
 */
const RelatedServicesPage = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    document.title = `${process.env.REACT_APP_TITLE} - Related Services`;

    const getText = async () => {
      try {
        const textData = await fetchText('_services/info.txt');
        setText(textData);
      } catch (error) {
        console.error("Error fetching text:", error);
      }
    };

    getText();
  }, []);

  return (
    <section id="related-services" className="bg-card-background p-6 md:p-8 rounded-xl shadow-lg mb-8">
      <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6 border-b-2 border-border-light pb-2 flex items-center">
        <Link className="w-7 h-7 mr-2" /> Related Services
      </h2>
      <div>
        {text.split('\n').map((line, index) => (
          <p key={index} className="text-lg text-text-dark">
            {line.trim() === '' ? <br /> : line}
          </p>
        ))}
      </div>
    </section>
  )
};

export default RelatedServicesPage;
